
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FormField extends Vue {
  @Prop({ default: '' }) label!: string;
  @Prop({ default: '' }) labelFor!: string;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: '' }) error!: string;
  @Prop({ default: false }) showError!: boolean;
  @Prop({ default: '' }) hint!: string;
  @Prop({ default: '' }) hintIcon!: string;
  @Prop({ default: false }) noMargin!: boolean;
}
